// extracted by mini-css-extract-plugin
export var header = "FormSectionHeader-module__header___0+iQT";
export var statusIcon = "FormSectionHeader-module__statusIcon___2QhVJ";
export var statusIconComplete = "FormSectionHeader-module__statusIconComplete___WedO+";
export var statusIconInProgress = "FormSectionHeader-module__statusIconInProgress___o--fM";
export var statusIconNotStarted = "FormSectionHeader-module__statusIconNotStarted___8M5Yc";
export var statusLabel = "FormSectionHeader-module__statusLabel___Bkn2H";
export var statusLabelComplete = "FormSectionHeader-module__statusLabelComplete___IXyMw";
export var statusRow = "FormSectionHeader-module__statusRow___OCt3f";
export var subtitle = "FormSectionHeader-module__subtitle___RqyEt";
export var title = "FormSectionHeader-module__title___a94Bi";
export var titleBlock = "FormSectionHeader-module__titleBlock___4FWQi";